module.exports = __webpack_public_path__ + "img/itinerary_map.cdd6aa43.svg";